export default "__VITE_ASSET__17820a42__"